import React, { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import type { Schema } from 'yup';
import { object, string } from 'yup';

import type { DialogChildrenProps } from '@components/Dialog';
import FormDialog from '@components/Dialog/FormDialog';

import { useSendFeedback } from '@hooks/api/notification';
import { useSession } from '@hooks/useSession';

import { formatName } from '@utils/format';

import type { FeedbackEmailType } from 'generated/types';

import FeedbackForm from './FeedbackForm';

const messages = defineMessages({
  required: {
    id: 'GLOBAL.required',
    defaultMessage: 'This field is required',
  },
});

type FormValues = {
  message: string;
  // submit: string | null;
};

interface FeedbackDialogListenerProps {
  type: FeedbackEmailType;
  children: (props: DialogChildrenProps) => React.ReactNode;
}

export default function FeedbackDialogListener(
  props: FeedbackDialogListenerProps
) {
  const { children, type } = props;
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const { formatMessage } = useIntl();
  const {
    state: { activeProfile },
  } = useSession();
  const [username, email] = [
    formatName(activeProfile?.first_name, activeProfile?.last_name),
    activeProfile?.email,
  ];
  const [sendFeedback, loading] = useSendFeedback(type);

  const initialValues: FormValues = {
    message: '',
    // submit: null,
  };
  const validationSchema: Schema<FormValues> = object().shape({
    message: string().required(formatMessage(messages.required)),
  });

  async function handleSubmit(values: FormValues) {
    if (!email || !username) {
      throw new Error('No logged in user found');
    }
    await sendFeedback({
      input: {
        email,
        name: username,
        message: values.message,
        type,
      },
    });
    handleClose();
  }

  return (
    <>
      {children({
        handleOpen,
        handleClose,
      })}
      <FormDialog
        content={<FeedbackForm type={type} />}
        dialogProps={{
          fullWidth: true,
        }}
        initialValues={initialValues}
        loading={loading}
        onClose={handleClose}
        onSubmit={handleSubmit}
        open={open}
        validationSchema={validationSchema}
      />
    </>
  );
}
